import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { TextMobile } from '@alfa-bank/site-text-v2/mobile';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { TextContent as Component } from './text-content';
import type { IDepsDesktop, IDepsMobile, TTextContent } from './models';
import styles from './styles/styles.css';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const TextContent = createWidget<IDepsDesktop, TTextContent>({
    Text,
    view: 'primary-medium',
    styles,
})(Component);

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const TextContentMobile = createWidget<IDepsMobile, TTextContent>({
    Text: TextMobile,
    view: 'primary-medium',
    styles,
})(Component);
